import React from "react";
import {graphql} from "gatsby";
import {Asset, Link} from "../../../../plugins/gatsby-plugin-atollon";
import parse from "html-react-parser";
import StructuredText from "../custom-structured-text-renderer";

const BannerCta = ({subtitle, title, h1, richContent, button, image, video, marginBottom, special}) => {
  return (
    <section className={`banner-cta${marginBottom ? ' banner-cta--mb' : ''}${special ? ' special' : ''}`}>
      <div className='banner-cta__inner'>
        <div className='banner-cta__media'>
          {video && <video src={video} autoPlay loop muted playsInline/>}
          {image && !video && <Asset asset={image}/>}
        </div>

        <div className='banner-cta__content'>
          { subtitle && <span className='banner-cta__subtitle' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(subtitle)}</span>}
          {h1 && <h1 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h1>}
          {!h1 && <h2 data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>{parse(title)}</h2>}
          {richContent && <div className='banner-cta__rich' data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'><StructuredText data={richContent}/></div>}
          {button.length > 0 &&
            <Link
              to={button[0].link[0].externalLink ? button[0].link[0].externalLink : button[0].link[0].internalLink?.permalink}
              data-sal='slide-up' data-sal-duration='1000' data-sal-easing='ease'>
              {button[0].title}
            </Link>}
        </div>
      </div>
    </section>
  )
}

export default BannerCta

export const query = graphql`
fragment BannerCtaProps on DatoCmsBannerCta {
  ... on DatoCmsBannerCta {
    id
    video
    subtitle
    title
    h1
    richContent {
      value
    }
    button {
      ...LinkWithTitleProps
    }
    image {
      ...InternalAssetProps
    }
    marginBottom
    special
  }
}
`;